import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Loader from '../../components/loader/Loader';
import ScratchGame from '../../components/scratch-game/ScratchGame';
import { axios_verifyVoucher } from '../../apiConnections/voucherApi';
import { useDispatch } from 'react-redux';
import { SET_GAME_DATA } from '../../Reducers/types';
import CannonGame from '../../components/cannon-game/CannonGame';
import BallsGameNew from '../../components/balls-game-new/BallsGameNew';
import { toast } from 'react-toastify';
import ErrorPage from '../error-page/ErrorPage';

export default function Game() {
    const dispatch = useDispatch()
    const Navigate = useNavigate();
    const { voucher_id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [currentGame, setCurrentGame] = useState("") //bubble, scratch, spin_wheel, cannon
    const [errorData, setErrorData] = useState(null);

    useEffect(() => {
        axios_verifyVoucher(voucher_id, verifyVoucherCallback, errorCallback)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [voucher_id])


    const verifyVoucherCallback = (response) => {
        if (response.status === 200) {
            if(response.data.error) {
                setErrorData({
                    title: response.data.error_title || null,
                    message: response.data.error_message || null,
                    error_redirect_url: response.data.error_redirect_url || null,
                });
                // toast.dismiss();
                // toast.error(response.data.error_message, {
                //     position: toast.POSITION.BOTTOM_CENTER,
                // });
            } else if (response.data.data) {
                dispatch({ type: SET_GAME_DATA, payload: { gameData: response.data.data } })
                // TODO: make dynamic
                setCurrentGame(
                    voucher_id === "3" ? "cannon" :
                        response.data?.data['game']?.game_type)
            }
        }
        setIsLoading(false)
    };

    const errorCallback = (error) => {
        setIsLoading(false)
        toast.dismiss();
        toast.error("Oops! Something went wrong.", {
            position: toast.POSITION.BOTTOM_CENTER,
        });
        Navigate("/");
    }

    if (errorData) {
        return <ErrorPage title={errorData.title} message={errorData.message} errorRedirectUrl={errorData?.error_redirect_url} />;
    }

    return (
        <>
            {isLoading && <Loader />}
            <div>
                {currentGame === "bubble" &&
                    <BallsGameNew />
                }
                {currentGame === "scratch" &&
                    <ScratchGame />
                }

                {currentGame === "cannon" &&
                    <CannonGame />
                }
            </div>
        </>
    )
}
